import { RosterItem } from './RosterItem';
import type { CharacterRow } from '../../../lib/types';
import type { DraftChild, ParentContact } from '../lib';

interface RosterStepProps {
  parent: ParentContact;
  draftChildren: DraftChild[];
  characterById: (id: number | null) => CharacterRow | null;
  onAddAnother: () => void;
  onSubmit: () => void;
  submitting: boolean;
  onFixChild: (draftId: string) => void;
}

export function RosterStep({
  parent,
  draftChildren,
  characterById,
  onAddAnother,
  onSubmit,
  submitting,
  onFixChild,
}: RosterStepProps) {
  const empty = draftChildren.length === 0;
  const firstCharacter = characterById(draftChildren[0]?.character_id ?? null);

  return (
    <div className="smash-stage">
      <div className="smash-banner-wrap">
        <div className="smash-banner">
          <img src="/burst.png" alt="" aria-hidden="true" className="smash-burst" />
          <h1 className="smash-banner__title">Confirm Selection</h1>
        </div>
        {firstCharacter?.image_url ? (
          <img
            className="smash-silhouette"
            src={firstCharacter.image_url}
            alt={firstCharacter.name}
          />
        ) : (
          <div className="smash-silhouette smash-silhouette--question">?</div>
        )}
      </div>
      <div className="smash-roster">
        <p className="smash-roster__contact">
          {parent.parent_name} · {parent.parent_email}
        </p>
        <ul className="smash-roster__list">
          {draftChildren.map((c) => (
            <RosterItem
              key={c.draftId}
              child={c}
              characterById={characterById}
              onEdit={onFixChild}
              disabled={submitting}
            />
          ))}
        </ul>
        <div className="smash-roster__actions">
          <button type="button" onClick={onAddAnother} disabled={submitting}>
            Add another child
          </button>
          <button
            type="button"
            onClick={onSubmit}
            disabled={submitting || empty}
          >
            {submitting ? 'Finishing…' : 'Finish'}
          </button>
        </div>
      </div>
    </div>
  );
}
